// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInPageLayout } from "@west/App/Widgets/Layout/SignInPageLayout";
import { color, hideElementOnPrint, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

signInPageLayout.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1px 1fr;
        grid-column-gap: 40px;
        grid-template-rows: auto;
        margin: 0 auto;
        padding-top: 50px;
        ${xScreen("lte", "md")} {
            grid-column-gap: 32px;
            padding-top: 15px;
        }

        ${xScreen("lt", "sm")} {
            grid-template-columns: 1fr;
            grid-row-gap: 32px;
            padding-top: 15px;
        }

        @media print {
            display: none !important;
        }
    `,
};

signInPageLayout.separator = {
    css: css`
        background-color: ${color("common.border")};
        width: 1px;
        height: ${({ isSignInPage }: any) => (isSignInPage ? "346px" : "auto")};
        ${xScreen("lt", "sm")} {
            height: 1px;
            width: 100%;
        }
    `,
};

signInPageLayout.createAccountSection = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

signInPageLayout.signInSection = {
    css: css`
        max-width: 370px;
        width: 100%;
        justify-self: flex-end;
        ${xScreen("lte", "md")} {
            justify-self: flex-start;
        }
        ${xScreen("lte", "xs")} {
            max-width: none;
        }
    `,
};

signInPageLayout.upperSection = {
    css: css`
        max-width: 370px;
        width: 100%;
        ${xScreen("lte", "xs")} {
            max-width: none;
        }
    `,
};
signInPageLayout.title = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
    `,
};
